var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
var TeamName = /** @class */ (function (_super) {
    __extends(TeamName, _super);
    function TeamName() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TeamName.prototype.render = function () {
        var classname = this.props.isServing ? this.props.clsName + " " + this.props.clsName + "--isServing" : this.props.clsName;
        return (React.createElement("div", { className: classname }, this.props.teamName));
    };
    return TeamName;
}(React.PureComponent));
export { TeamName };
//# sourceMappingURL=TeamName.js.map